package com.ives.utils.math;

class Vector3D {
	public var x:Float;
	public var y:Float;
	public var z:Float;

	public function new(x:Float = 0, y:Float = 0, z:Float = 0) {
		this.x = x;
		this.y = y;
		this.z = z;
	}

	public function setTo(vector:Vector3D) {
		x = vector.x;
		y = vector.y;
		z = vector.z;
	}

	public function add(vector:Vector3D):Vector3D {
		x += vector.x;
		y += vector.y;
		z += vector.z;

		return this;
	}

	public function subtract(vector:Vector3D):Vector3D {
		x -= vector.x;
		y -= vector.y;
		z -= vector.z;

		return this;
	}

	public function dot(vector:Vector3D):Float{
		return x * vector.x + y * vector.y + z * vector.z;
	}

	public function clone():Vector3D {
		return new Vector3D(x, y, z);
	}

	public function length2():Float{
		return x * x + y * y + z * z;
	}

	public function length():Float{
		return Math.sqrt(length2());
	}

	public function distanceFrom(vector:Vector3D):Float{
		return this.clone().subtract(vector).length();
	}

	public function normalize():Vector3D{
		var length2:Float = length2();

		if(length2 > 0)
			scale(1 / Math.sqrt(length2));

		return this;
	}

	public function setLengthTo(length:Float):Vector3D{
		var length2:Float = length2();

		if(length2 > 0)
			scale(length / Math.sqrt(length2));

		return this;
	}

	public function scale(scale:Float):Vector3D{
		this.x *= scale;
		this.y *= scale;
		this.z *= scale;

		return this;
	}

	public function cross(v2:Vector3D){
		var x = this.y * v2.z - this.z * v2.y;
		var y = v2.x * this.z - v2.z * this.x;

		this.z = this.x * v2.y - this.y * v2.x;
		this.x = x;
		this.y = y;

		return this;
	}

	public function toString():String{
		return '${x},${y},${z}';
	}

	public function toArray():Array<Float>{
		return [x, y, z];
	}

	public static function fromArray(data:Array<Float>):Vector3D{
		return new Vector3D(data[0], data[1], data[2]);
	}

	public static function fromString(values:String):Vector3D{
		if(values == null)
			return null;

		var data = values.split(",");

		return new Vector3D(Std.parseFloat(data[0]), Std.parseFloat(data[1]), Std.parseFloat(data[2]));
	}
}
